import AboutImg from '../Assets/template/aboutIcon.svg';
import AboutTemplate from '../Assets/template/about.png';

const AboutSection = () => {
return (
 <div style={styles.aboutContainer}>
  <div style={styles.contentWrapper}>
   
    <img src={AboutTemplate} alt="About Template" style={styles.aboutTemplateImage} />
    <div style={styles.aboutTemplateWrapper}>
    <img src={AboutImg} alt="About" style={styles.aboutImage} />
    </div>
    <h1 style={styles.aboutTitle}>About</h1>
        <span style={styles.aboutSubtitle}>DISA</span>
        <span style={styles.italicBoldText}>"Digital Irrigator System Assessment"</span>

        <div style={styles.textWrapper}>  
        <p style={styles.aboutDescription}>
        an innovative platform that leverages advanced technologies, to optimize irrigation systems across Bohol. By analyzing climate patterns, water usage, and crop needs, DISA ensures a more efficient and sustainable water distribution system for farmers. This empowers local agriculture, enhances crop yields, and strengthens food security, driving innovation in the country’s farming practices.
        </p>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;

const styles = {
  aboutContainer: {
    background: 'white', 
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    color: 'black',
    marginTop: '0px',
  },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'row', 

    maxWidth: '1300px',
    marginTop: '0px',
    position: 'relative',
    flexWrap: 'wrap',
  },
  aboutTemplateWrapper: {
    position: 'relative', 
    zIndex: 0,
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    width: '100%', 
    height: '100%', 
    marginTop: '-650px',
    marginLeft: '600px', 
  },
  
  aboutTemplateImage: {
    width: '850px',
    height: '700px',
    maxWidth: '1000px',  
    marginLeft: '0',    
    paddingLeft: '0',
    marginRight: '0px', 

  },
  aboutImage: {
    width: '350px',
    height: '350px',
    maxWidth: '500px',
    marginTop: '90px', 
    marginLeft: '-750px', 
  },
  textWrapper: {
    paddingLeft: '1px',
  
  },
  aboutTitle: {
    fontSize: '35px',
    fontFamily: 'Poppins, sans-serif',
    fontWeight: '600',
    marginBottom: '0px',
    textAlign: 'center',
    letterSpacing: '2px',
    textTransform: 'uppercase',
    marginLeft: '150px',
    marginTop: '-400px',
  },
  aboutDescription: {
    fontSize: '17px',
    fontFamily: 'Poppins, sans-serif',
    lineHeight: '1.9',
    letterSpacing: '1px',
    maxWidth: '750px',
    textAlign: 'justify',
    marginTop: '-490px',
    marginLeft: '800px',
  },
  aboutSubtitle: {
    fontWeight: 'bold',
    fontSize: '55px',
    fontStyle: 'italic',
    maxWidth: '90px',
    color: ' #B8860B',
    marginLeft: '-80px',
    marginTop: '-350px', 
  },
  italicBoldText: {
    fontWeight: 'bold',
    fontSize: '18px',
    fontStyle: 'italic',
    maxWidth: '250px',
    color: ' #B8860B',
    marginLeft: '-90px',
    marginTop: '-270px', 
  },

  line: {
    width: '80%',
    height: '2px',
 
    marginTop: '40px',
    marginBottom: '40px',
    borderRadius: '50px',
  },
};
